import jquery from 'jquery';
import EFOcats_answer from './efocats_answer.js';

/**
 * tmp[0] === "set-adress"の時の回答欄設置処理
 */
export default class EFOcats_answer_set_address extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    elem.find('.inner').each(() => {
      jquery(this).find('input,select,textarea').eq(answer.index).attr('name', answer.name);
    });
  }
}
